import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-pledge',
    templateUrl: './question-pledge.component.html',
    styleUrls: ['./question-pledge.component.scss'],
    standalone: false
})
export class QuestionPledgeComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;

  uniqueControlName = `question-pledge-${newGuid()}`;

  constructor() { }

  ngOnInit(): void {
  }

}
